export default __webpack_public_path__ + "static/hotblack-tech-floorplan-bd2040d23d9cb98031beaf0e308646ef.png";